import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(name, email, password);
      toast.success("Welcome to SpareHours.");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6 py-10">
      <div className="w-full max-w-md border border-neutral-200 bg-white rounded-xl p-8">
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-500 mb-3">CREATE ACCOUNT</div>
        <h1 className="font-display font-black tracking-tighter text-3xl mb-6">Book a room. Or list one.</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
          <div>
            <Label>Name</Label>
            <Input required value={name} onChange={(e) => setName(e.target.value)} className="mt-2 h-11" data-testid="signup-name" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11" data-testid="signup-email" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11" data-testid="signup-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-full" data-testid="signup-submit">
            {loading ? "…" : "Create account"}
          </Button>
          <p className="text-[11px] text-neutral-400 text-center leading-relaxed" data-testid="signup-terms">
            By creating an account you agree to our{" "}
            <Link to="/terms" className="underline hover:text-[#FF4500]">Terms of Service</Link> and{" "}
            <Link to="/privacy" className="underline hover:text-[#FF4500]">Privacy Policy</Link>.
          </p>
        </form>
        <div className="mt-6 text-sm text-neutral-600 text-center">
          Have an account? <Link to="/login" className="underline underline-offset-4 hover:text-[#FF4500]">Log in</Link>
        </div>
      </div>
    </div>
  );
}
